<wiz-h-divider width="100%" height="100%" gap="0" padding="5px">
  <wiz-hgroup width="350px" height="100%">
    <multi-display #mdMain width="100%" height="100%" [config]="mainConfig">
      <wiz-hgroup target="icons">
        <wiz-icon #btnExport [wizTooltip]="'$.common.export.$'" class="image-purple"
          (click)="doAct('export')">download</wiz-icon>
        <wiz-icon #btnImport [wizTooltip]="'$.common.import.$'" class="image-purple"
          (click)="doAct('import')">upload</wiz-icon>
        <wiz-icon #btnRemove [wizDisabled]="!currentStyle || cantDelete" class="image-purple"
          [wizTooltip]="'$.common.delete.$'" (click)="askForDelete()">delete</wiz-icon>
      </wiz-hgroup>

      <wiz-hgroup target="title" [verticalAlign]="'center'" class="add-btn" gap="10" padding="0 0 10px">
        <wiz-icon #btnCreate [wizTooltip]="'$.style.add.$'" tooltipPlacement="right" class="image-back-orange"
          (click)="askForAdd()" [wizDisabled]="cantCreate">add</wiz-icon>
        <wiz-label class="titleLabel" [wizLabel]="'$.style.add.$'" [wizTextBehavior]="'truncate'"
          width="100%"></wiz-label>
      </wiz-hgroup>
    </multi-display>
  </wiz-hgroup>

  <wiz-group width="100%" minWidth="600px" height="100%" [wizDisabled]="cantUpdate">
    <!-- Groupe de présentation lorsque pas de sélection -->
    <wiz-vgroup #vgDemo [visible]=false height="100%" width="100%" gap="10" class="section-container-parent">
      <widget-renderer class="view-widget" [title]="'$.style.title.$'" [description]="'$.style.home.description.$'">
      </widget-renderer>
    </wiz-vgroup>

    <!-- zone détail "vraie" -->
    <wiz-vgroup class="section-container-parent" #vgEdition wizValidationContainer width="100%" minWidth="600px"
      height="100%" gap="10" [visible]=false>
      <!-- entête d'édition -->
      <wiz-hgroup wizValidationContainer width="100%" class="section-container" padding="10px" gap="10">
        <wiz-text-input #tiCode class="upper-case-input" [wizPlaceholder]="'$.common.define.$'"
          [wizValidator]="uniqueCodeValidator()" [wizLabel]="'$.common.code.$'" width="160px" [wizShowErrors]="true"
          [wizMandatory]="true" [wizMaxChars]="20">
        </wiz-text-input>
        <wiz-text-input #tiVisionCode [wizDisabled]="true" [wizLabel]="'$.phys-template.vision.$'"
          width="160px"></wiz-text-input>
        <wiz-translation-basic #trsDesc [wizTranslationMode]="'textarea'" [maxTranslation]="6"
          [wizLabel]="'$.common.description.$'" width="315px" height="80px"></wiz-translation-basic>
        <wiz-spacer width="100%"></wiz-spacer>

        <!-- boutons d'action -->
        <wiz-vgroup gap="0" height="100%" width="250px" horizontalAlign="center">
          <wiz-button #btnSave [wizIcon]="'arrow-right'" [wizLabel]="'$.common.save.modification.$'"
            [iconPlacement]="'right'" [wizDisabled]="disableButtons() || (cantUpdate && cantCreate)"
            (wizClick)="doMerge()"></wiz-button>
          <wiz-button #btnCancel class="cancel-button" [wizIcon]="'arrow-left'"
            [wizLabel]="'$.common.cancel.modification.$'" [wizDisabled]="disableCancel() || (cantUpdate && cantCreate)"
            (wizClick)="doCancel()"></wiz-button>
        </wiz-vgroup>
      </wiz-hgroup>

      <!-- détail d'édition -->
      <!--liste des lignes du style -->
      <wiz-vgroup width="100%" minWidth="300px" height="100%" class="section-container" padding="10px" gap="10"
        style="overflow-x: auto">
        <wiz-hgroup target="title" [verticalAlign]="'center'" class="add-btn" gap="10" padding="0 0 10px">
          <wiz-icon [wizTooltip]="'$.style.line.add.$'" class="image-back-orange"
            (click)="askForAddLine()">add</wiz-icon>
          <wiz-label class="titleLabel" [wizLabel]="'$.style.line.add.$'" [wizTextBehavior]="'truncate'"
            width="100%"></wiz-label>
        </wiz-hgroup>

        <wiz-list #lstStyles width="100%" height="100%" [itemHeight]="100" [wizItemRenderer]="lineRenderer"
          [wizDisabled]="cantUpdate && cantCreate"></wiz-list>
      </wiz-vgroup>
    </wiz-vgroup>
  </wiz-group>
</wiz-h-divider>